import { baseApi } from "../redux/baseAPI";

var section = {}
export const documateApi = baseApi.injectEndpoints({
  tagTypes: ["DocumateList", "DocumateAllergiesList", "DocumatePastMedicalHistoryList", "DocumateMedicationsList", "DocumateHistoriesList", "DocumateLabsList", "DocumateLabResultsList", "DocumateReferralsList", "DocumateRadiologyList", "DocumateProceduresList", "DocumateVitalsList", "DocumateAssessmentsList", "DocumateDocumentsList"],
  endpoints: (builder) => ({
    getDocumateList: builder.query({
      query: (body) => {
        if (body?.pid){
        return {
          url: `/documate/build_note.json`,
          method: "GET",
          params: body,
        };}
      },
      providesTags: ["DocumateList"],
    }),
    getAllergiesList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_documate_sections.json`,
          method: "GET",
          params: {"section": "allergies", "pid": pid},
        };}
      },
      providesTags: ["DocumateAllergiesList"],
    }),
    getPastMedicalHistoryList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_documate_sections.json`,
          method: "GET",
          params: {"section": "past_medical_history", "pid": pid},
        };}
      },
      providesTags: ["DocumatePastMedicalHistoryList"],
    }),
    getMedicationsList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_documate_sections.json`,
          method: "GET",
          params: {"section": "medications", "pid": pid},
        };}
      },
      providesTags: ["DocumateMedicationsList"],
    }),
    getHistoriesList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/histories/get_history.json?type=`,
          method: "GET",
          params: {"pid": pid},
        };}
      },
      providesTags: ["DocumateHistoriesList"],
    }),
    getLabsList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_documate_sections.json`,
          method: "GET",
          params: {"section": "labs", "pid": pid},
        };}
      },
      providesTags: ["DocumateLabsList"],
    }),
    getLabResultsList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_documate_sections.json`,
          method: "GET",
          params: {"section": "lab_results", "pid": pid},
        };}
      },
      providesTags: ["DocumateLabResultsList"],
    }),
    getReferralsList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_documate_sections.json`,
          method: "GET",
          params: {"section": "referrals", "pid": pid},
        };}
      },
      providesTags: ["DocumateReferralsList"],
    }),
    getRadiologyList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_documate_sections.json`,
          method: "GET",
          params: {"section": "radiology", "pid": pid},
        };}
      },
      providesTags: ["DocumateRadiologyList"],
    }),
    getProceduresList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_documate_sections.json`,
          method: "GET",
          params: {"section": "procedures", "pid": pid},
        };}
      },
      providesTags: ["DocumateProceduresList"],
    }),
    getVitalsList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_documate_sections.json`,
          method: "GET",
          params: {"section": "vital_signs", "pid": pid},
        };}
      },
      providesTags: ["DocumateVitalsList"],
    }),
    getAssessmentsList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_documate_sections.json`,
          method: "GET",
          params: {"section": "assessment_and_plan", "pid": pid},
        };}
      },
      providesTags: ["DocumateAssessmentsList"],
    }),
    getDocumentsList: builder.query({
      query: (pid) => {
        if (pid){
        return {
          url: `/documate/get_document.json`,
          method: "GET",
          params: {"pid": pid},
        };}
      },
      providesTags: ["DocumateDocumentsList"],
    }),
    processSection: builder.mutation({
      query: (body) => ({
        url: `/documate/process_section.json`,
        method: "POST",
        data: body.section,
        params: {
          encounter: body.encounter,
          pid: body.pid,
        },
      }),
    }),
    getPromptData: builder.query({
      query: (body) => {
        return {
          url: `/documate/get_gpt_data.json`,
          method: "GET",
          params: body,
        };
      }
    }),
    deleteItem: builder.mutation({
      query: (body) => {
       section = body
       return {
        url: `/documate/del_gpt_section_item.json`,
        method: "GET",
        data: body,
        params: body,
      }
    },
    //invalidatesTags: [{ type: section.section }],
    }),
    addLabDocumate : builder.mutation({
      query: (body) => {
       return {
        url: `/documate/attach_items_with_lab.json`,
        method: "POST",
        data: body,
      }
    },
    invalidatesTags: [{ type: section.section }],
    }),
    undoMedication : builder.mutation({
      query: (body) => {
       return {
        url: `/documate/undo_gpt_action.json`,
        method: "POST",
        data: body,
      }
    },
      invalidatesTags: [{ type: "DocumateMedicationsList" }],
    }),
    addRadiologyDocumate : builder.mutation({
      query: (body) => {
       return {
        url: `/documate/attach_items_with_radiology.json`,
        method: "POST",
        data: body,
      }
    },
    invalidatesTags: [{ type: section.section }],
    }),
    getHopiSmartPhrases: builder.query({
      query: (queryParams = null) => {
        return {
          url: `/smart_phrase/index.json`,
          method: "GET",
          params: queryParams,
        };
      },
      transformResponse: (response, meta, arg) => response,
      providesTags: ["DocumateHopiSmartPhrases"],
    }),
  }),
});

export const {
    useGetDocumateListQuery,
    useProcessSectionMutation,
    useGetPromptDataQuery,
    useGetAllergiesListQuery,
    useGetPastMedicalHistoryListQuery,
    useGetMedicationsListQuery,
    useGetHistoriesListQuery,
    useGetLabsListQuery,
    useGetLabResultsListQuery,
    useGetReferralsListQuery,
    useGetRadiologyListQuery,
    useGetProceduresListQuery,
    useGetVitalsListQuery,
    useGetAssessmentsListQuery,
    useGetDocumentsListQuery,
    useDeleteItemMutation,
    useAddLabDocumateMutation,
    useUndoMedicationMutation,
    useAddRadiologyDocumateMutation,
} = documateApi;
